import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import PrisonLayout from '../../components/PrisonLayout';
import PrisonOverview from './PrisonOverview';
import OrderManagement from './OrderManagement';
import InventoryManagement from './InventoryManagement';

function PrisonDashboard() {
  const { user } = useApp();

  if (!user || user.type !== 'prison') {
    return <div>Access denied</div>;
  }

  return (
    <PrisonLayout>
      <Routes>
        <Route path="/" element={<PrisonOverview />} />
        <Route path="/orders" element={<OrderManagement />} />
        <Route path="/inventory" element={<InventoryManagement />} />
      </Routes>
    </PrisonLayout>
  );
}

export default PrisonDashboard;